import { CreateCompany } from './CreateCompany';
import './styles/CompanyDetail.scss';
import { UpdateCompany } from './UpdateCompany';

interface Props {
  companyId?: number;
  closeHandler: Function;
  newCompany?: boolean;
  noAdmin?: boolean;
  onlyEdit?: boolean;
}

export function CompanyDetail(props: Props) {
  if (props.newCompany || !props.companyId) {
    return <CreateCompany closeHandler={props.closeHandler} />;
  }

  return (
    <UpdateCompany
      companyId={props.companyId}
      closeHandler={props.closeHandler}
      noAdmin={props.noAdmin}
      onlyEdit={props.onlyEdit}
    />
  );
}
